import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const merchantTransactionCharge = {
  namespaced: true,

  state: () => ({
    isPercentageDefaultChargeType: false,
    isRangeDefaultChargeType: false,
    isCreateOrUpdateChargeSuccessful: false,
    isEditChargeClicked: false,
    // --------------------------------
    appTranscationChargeTypes: [],
    defaultAppTransactionChargeType: {},
    appTransactionChargePercentage: {},
    allAppChargeRanges: [],
    pendingAppChargeRange: [],
    approvedAppChargeRange: [],
    // --------------------------------
    defaultMerchantTransactionChargeType: {},
    merchantTransactionChargePercentage: {},
    allMerchantChargeRanges: [],
    pendingMerchantChargeRange: [],
    approvedMerchantChargeRange: []
  }),

  getters: {
    _isPercentageDefaultChargeType: state => state.isPercentageDefaultChargeType,
    _isRangeDefaultChargeType: state => state.isRangeDefaultChargeType,
    _isCreateOrUpdateChargeSuccessful: state => state.isCreateOrUpdateChargeSuccessful,
    _isEditChargeClicked: state => state.isEditChargeClicked,
    _chargeUpdateData: state => state.chargeUpdateData,
    // ---------------------------------------------
    _appTransactionChargeTypes: state => state.appTransactionChargeTypes,
    _defaultAppTransactionChargeType: state => state.defaultAppTransactionChargeType,
    _appTransactionChargePercentage: state => state.appTransactionChargePercentage,
    _allAppChargeRanges: state => state.allAppChargeRanges,
    _pendingAppChargeRange: state => state.pendingAppChargeRange,
    _approvedAppChargeRange: state => state.approvedAppChargeRange,
    // ---------------------------------------------
    _defaultMerchantTransactionChargeType: state => state.defaultMerchantTransactionChargeType,
    _merchantTransactionChargePercentage: state => state.merchantTransactionChargePercentage,
    _allMerchantChargeRanges: state => state.allMerchantChargeRanges,
    _pendingMerchantChargeRange: state => state.pendingMerchantChargeRange,
    _approvedMerchantChargeRange: state => state.approvedMerchantChargeRange
  },

  mutations: {
    IS_PERCENTAGE_DEFAULT_CHARGE_TYPE (state, value) {
      state.isPercentageDefaultChargeType = value
    },
    IS_RANGE_DEFAULT_CHARGE_TYPE (state, value) {
      state.isRangeDefaultChargeType = value
    },
    IS_CREATE_OR_UPDATE_CHARGE_SUCCESSFUL (state, value) {
      state.isCreateOrUpdateChargeSuccessful = value
    },
    IS_EDIT_CHARGE_CLICKED (state, value) {
      state.isEditChargeClicked = value
    },
    CHARGE_UPDATE_DATA (state, value) {
      state.chargeUpdateData = value
    },
    // -----------------------------------------------
    APP_TRANSACTION_CHARGE_TYPES (state, data) {
      state.appTransactionChargeTypes = data
    },
    DEFAULT_APP_TRANSACTION_CHARGE_TYPE (state, data) {
      state.defaultAppTransactionChargeType = data
    },
    APP_TRANSACTION_CHARGE_PERCENTAGE (state, data) {
      state.appTransactionChargePercentage = data
    },
    ALL_APP_CHARGE_RANGES (state, data) {
      state.allAppChargeRanges = data
    },
    PENDING_APP_CHARGE_RANGE (state, data) {
      state.pendingAppChargeRange = data
    },
    APPROVED_APP_CHARGE_RANGE (state, data) {
      state.approvedAppChargeRange = data
    },
    // -----------------------------------------------
    DEFAULT_MERCHANT_TRANSACTION_CHARGE_TYPE (state, data) {
      state.defaultMerchantTransactionChargeType = data
    },
    MERCHANT_TRANSACTION_CHARGE_PERCENTAGE (state, data) {
      state.merchantTransactionChargePercentage = data
    },
    ALL_MERCHANT_CHARGE_RANGES (state, data) {
      state.allMerchantChargeRanges = data
    },
    PENDING_MERCHANT_CHARGE_RANGE (state, data) {
      state.pendingMerchantChargeRange = data
    },
    APPROVED_MERCHANT_CHARGE_RANGE (state, data) {
      state.approvedMerchantChargeRange = data
    }
  },

  actions: {
    CancelChargeUpdate ({ commit }) {
      commit('IS_EDIT_CHARGE_CLICKED', false)
      commit('CHARGE_UPDATE_DATA', {})
    },

    // ========== APP TRANSACTION CHARGES =============
    CreateAppTransactionCharge ({ rootState, dispatch }, { chargeType, data, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post(`TransactionCharge/CreateTransactionCharge${chargeType}`, data, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 1000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UpdateAppTransactionCharge ({ rootState, dispatch }, { chargeType, data, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post(`TransactionCharge/UpdateTransactionCharge${chargeType}`, data, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              dispatch('CancelChargeUpdate')
              rootState.loading = false
              resolve(data)
            }, 1000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    ApproveAppTransactionCharge ({ rootState, dispatch }, { chargeType, data, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post(`TransactionCharge/ApproveTransactionCharge${chargeType}`, data, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 1000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    switchAppDefaultChargeType ({ rootState, dispatch }, { chargeType, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`TransactionChargesType/SwitchTransactionTypeto${chargeType}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 1000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    // -----------------------------------------------------
    GetAppTransactionChargeTypes ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('TransactionChargesType/GetTransactionChargesType', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            // rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAppDefaultTransactionChargeType ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get('TransactionChargesType/GetTransactionChargesTypeDefault', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAppTransactionChargePercentage ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get('TransactionCharge/GetTransactionChargePercentage', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllAppTransactionChargeRange ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get('TransactionCharge/GetAllTransactionChargeRange', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetApprovedAppTransactionChargeRange ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get('TransactionCharge/GetApprovedTransactionChargeRange', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetPendingAppTransactionChargeRange ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get('TransactionCharge/GetPendingTransactionChargeRange', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetByIdAppTransactionChargeRange ({ rootState, dispatch }, { id, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get('TransactionCharge/GetByIdTransactionChargeRange', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    // ========== MERCHANT TRANSACTION CHARGES ========
    CreateMerchantTransactionCharge ({ rootState, dispatch }, { chargeType, data, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post(`MerchantTransactionCharge/CreateMerchantTransactionCharge${chargeType}`, data, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UpdateMerchantTransactionCharge ({ rootState, dispatch }, { chargeType, data, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post(`MerchantTransactionCharge/UpdateMerchantTransactionCharge${chargeType}`, data, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            dispatch('CancelChargeUpdate')
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 1000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    ApproveMerchantTransactionCharge ({ rootState, dispatch }, { chargeType, data, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post(`MerchantTransactionCharge/ApproveMerchantTransactionCharge${chargeType}`, data, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 1000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    switchMerchantDefaultChargeType ({ rootState, dispatch }, { chargeType, id, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`MerchantTransactionChargeType/SwitchMerchantTransactionTypeto${chargeType}?MerchantId=${id}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 1000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    // ------------------------------------------------------
    GetMerchantDefaultTransactionChargeType ({ rootState, dispatch }, { id, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`MerchantTransactionChargeType/GetMerchantTransactionChargeType?MerchantId=${id}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            // rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetMerchantTransactionChargePercentage ({ rootState, dispatch }, { id, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`MerchantTransactionCharge/GetMerchantTransactionChargePercentage?MerchantId=${id}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              // rootState.loading = false
              resolve(data)
            }, 1500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetByIdMerchantTransactionChargeRange ({ rootState, dispatch }, { id, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`MerchantTransactionCharge/GetByIdMerchantTransactionChargeRange?MerchantTransactionChargeRangeId=${id}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllMerchantTransactionChargeRange ({ rootState, dispatch }, { id, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`MerchantTransactionCharge/GetAllMerchantTransactionChargeRange?merchantId=${id}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetPendingMerchantTransactionChargeRange ({ rootState, dispatch }, { id, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`MerchantTransactionCharge/GetPendingMerchantTransactionChargeRange?merchantId=${id}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetApprovedMerchantTransactionChargeRange ({ rootState, dispatch }, { id, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`MerchantTransactionCharge/GetApprovedMerchantTransactionChargeRange?merchantId=${id}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default merchantTransactionCharge
